import PanelGroup from './components/PanelGroup';

const selectors = {
  node: '.node-home-members',
};

export default class HomeMembers {
  constructor(element) {
    this.element = element;
    this.selectors = selectors;
    this.createPanelGroups();
    this.addEventListeners();
  }

  createPanelGroups() {
    this.nodes.forEach((node) => {
      if (!node.PanelGroup) {
        node.PanelGroup = new PanelGroup(node, this.selectors);
      }
    });
  }

  expandedHandler({ target }) {
    const closeThese = Array.from(this.nodes).filter((node) => node !== target);
    closeThese.forEach((node) => node.PanelGroup.deactivate());
  }

  addEventListeners() {
    this.element.addEventListener('expanded', this.expandedHandler.bind(this));
  }

  get nodes() {
    return this.element.querySelectorAll(this.selectors.node);
  }
}
